export default function prependZero(number) {
  // redux form stores numbers as string
  return number.charAt(0) !== '0' && number.length < 2 ? `0${number}` : number
}
